// removed by extract-text-webpack-plugin
module.exports = {"container":"ServiceSchedulerView__container___2096B"};